var parent = require('../../actual/array');
require('../../modules/es.promise');
require('../../modules/esnext.array.from-async');
// TODO: Remove from `core-js@4`
require('../../modules/esnext.array.at');
// TODO: Remove from `core-js@4`
require('../../modules/esnext.array.filter-out');
require('../../modules/esnext.array.filter-reject');
require('../../modules/esnext.array.is-template-object');
require('../../modules/esnext.array.last-item');
require('../../modules/esnext.array.last-index');
require('../../modules/esnext.array.unique-by');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// /tmp/build_310c34ba/node_modules/core-js/full/array/index.js
// module id = 422
// module chunks = 2